import React from 'react';
import backgroundImage from '../img/header.jpg';

import mainLogo from '../img/logo-white.png';

import adweek from '../img/logos/adweek.png';
import awesomenesstv from '../img/logos/awesomenesstv_logo.png';
import forbes from '../img/logos/forbes.png';
import huffpost from '../img/logos/huffpost.png';
import phlogo from '../img/logos/phlogo.png';
import sfbt from '../img/logos/sfbt.png';
import sierra from '../img/sierra-nodle.jpeg';
import john from '../img/john.jpeg';

import linkedinStats from '../img/linkedinStats.png';
import CLS from '../img/CLS.png';

import bluerun from '../img/logos/clients/bluerunventures.png';
import carbon from '../img/logos/clients/carbon.png';
import fossa from '../img/logos/clients/fossa.png';
import nodle from '../img/logos/clients/nodle.io.png';
import radius8 from '../img/logos/clients/radius8.png';
import FifFive from '../img/logos/clients/15Five.png';

import AnchorLink from 'react-anchor-link-smooth-scroll';

import '../../src/layouts/fonts/ionicons/css/ionicons.min.css';

const IndexPage = () => (
  <div>
    <section className="background-image-holder">
      <div
        className="slice holder-item holder-item-light has-bg-cover bg-size-cover"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundPosition: 'left center',
        }}
      >
        <span className="mask bg-base-2 alpha-6" />
        <div className="container slice-lg slice--offset-top">
          <div className="row cols-xs-space align-items-center text-center text-md-left justify-content-center">
            <div className="col-lg-7">
              <div className="text-center mt-5">
                <img
                  src={mainLogo}
                  style={{ width: '200px' }}
                  className="img-fluid"
                />
                <h2 className="heading display-4 font-weight-400 text-white mt-4 mb-0">
                  <span className="font-weight-700">We Make Influencers</span>
                </h2>
                <h2 className="heading heading-4 font-weight-400 text-white">
                  <span className="font-weight-700">
                    Want to become a LinkedIn influencer? <br /> Join our
                    LinkedIn Elite program.
                  </span>
                </h2>
                <AnchorLink
                  href="#linkedIn"
                  className="btn btn-styled btn-white btn-circle mt-4"
                  data-scroll-to="#scroll_section"
                >
                  Learn More
                </AnchorLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* <section className="slice-xxs sct-color-1">
      <div className="container">
        <div className="row">
          <div
            className="client-logo client-logo--style-1 col-lg-2"
            style={{
              maxHeight: '100px',
              padding: '30px',
            }}
          />
          <img
            src={bluerun}
            className="client-logo client-logo--style-1 col-lg-2 col-md-3 col-sm-3 col-xs-4"
            style={{
              maxHeight: '100px',
              padding: '30px',
            }}
          />
          <img
            src={carbon}
            className="client-logo client-logo--style-1 col-lg-2 col-md-3 col-sm-3 col-xs-4"
            style={{
              height: '105px',
              padding: '30px',
            }}
          />
          <img
            src={fossa}
            className="client-logo client-logo--style-1 col-lg-2 col-md-3 col-sm-3 col-xs-4"
            style={{
              height: '100px',
              padding: '30px',
            }}
          />
          <img
            src={nodle}
            className="client-logo client-logo--style-1 col-lg-2 col-md-3 col-sm-3 col-xs-4"
            style={{
              height: '90px',
              padding: '30px',
            }}
          />
        </div>
      </div>
    </section> */}

    <section id="linkedIn" className="slice-lg sct-color-2">
      <div className="container container-lg">
        <div className="row cols-xs-space cols-sm-space cols-md-space align-items-center">
          <div className="col-lg-6 order-lg-2 animate-on-scroll fadeIn">
            <div className="block block-image-holder z-depth-3">
              <div className="block-image">
                <img src={linkedinStats} className="block-image" />
              </div>
            </div>
          </div>

          <div
            className="col-lg-6 order-lg-1 animate-on-scroll fadeIn"
            data-wow-delay="0.3s"
          >
            <div className="feature feature--boxed-border floating-content sct-color-1 border-0 no-bg px-0">
              <h2 className="heading heading-5 c-gray-light text-uppercase strong-600">
                LinkedIn Elite Program
              </h2>
              <h2 className="heading heading-3 strong-600 mt-4">
                We turn you into a LinkedIn influencer, so your leads know who
                you are before you reach out.
              </h2>

              <a
                href="https://jamocha.typeform.com/to/sK6FkT"
                className="btn btn-styled btn-base-1 btn-circle mt-5"
              >
                Sign Up Today
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="tech" className="slice-lg sct-color-2">
      <div className="container container-lg">
        <div className="row cols-xs-space cols-sm-space cols-md-space align-items-center">
          <div className="col-lg-6 order-lg-1 animate-on-scroll fadeIn">
            <div className="block block-image-holder z-depth-3">
              <div className="block-image">
                <img src={CLS} className="block-image" />
              </div>
            </div>
          </div>

          <div
            className="col-lg-6 order-lg-2 animate-on-scroll fadeIn"
            data-wow-delay="0.3s"
          >
            <div className="feature feature--boxed-border floating-content sct-color-1 border-0 no-bg px-0">
              <h2 className="heading heading-5 c-gray-light text-uppercase strong-600">
                Our Content Lead System (CLS)
              </h2>
              <h2 className="heading heading-3 strong-600 mt-4">
                All clients have access to our CLS. <br /> <br />
                As we're helping you build your influence, we help you track it
                as well.
              </h2>

              <a
                href="https://medium.com/@themehakvohra/introducing-the-jamocha-content-lead-system-cls-270fb76e7991"
                className="btn btn-styled btn-base-1 btn-circle mt-5"
              >
                Read More
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="slice-xxs logoBackColor">
      <div className="container">
        <div className="swiper-js-container">
          <div className="swiper-container">
            <div className="swiper-wrapper">
              <div className="swiper-slide col-12">
                <img
                  src={adweek}
                  className="client-logo client-logo--style-3 col-lg-2 col-md-3 col-sm-6"
                />
                <img
                  src={awesomenesstv}
                  className="client-logo client-logo--style-3 col-lg-2 col-md-3 col-sm-6"
                />
                <img
                  src={phlogo}
                  className="client-logo client-logo--style-3 col-lg-2 col-md-3 col-sm-6"
                />
                <img
                  src={forbes}
                  className="client-logo client-logo--style-3 col-lg-2 col-md-3 col-xs-6"
                />
                <img
                  src={huffpost}
                  className="client-logo client-logo--style-3 col-lg-2 col-md-3 col-xs-6"
                />
                <img
                  src={sfbt}
                  className="client-logo client-logo--style-3 col-lg-2 col-md-3 col-xs-6"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="slice-lg sct-color-2">
      <div className="container">
        <div className="section-title section-title--style-1 text-center">
          <h3 className="section-title-inner heading-2 strong-500 text-normal">
            How Our Program Works:
          </h3>
          <span className="section-title-delimiter clearfix d-none" />
        </div>

        <span className="clearfix" />

        <div className="row-wrapper">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="feature feature--boxed-border">
                <div className="icon-block icon-block--style-1-v1">
                  <div className="block-icon">
                    <span className="icon-number">1</span>
                  </div>
                  <div className="block-content">
                    <h3 className="heading heading-6 strong-600">
                      We Audit Your Profile.
                    </h3>
                    <p className="mt-2 c-gray-light">
                      We optimize your profile for higher conversions when
                      people visit your page.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="feature feature--boxed-border">
                <div className="icon-block icon-block--style-1-v1">
                  <div className="block-icon">
                    <span className="icon-number">2</span>
                  </div>
                  <div className="block-content">
                    <h3 className="heading heading-6 strong-600">
                      We Send You Relevant Topics.
                    </h3>
                    <p className="mt-2 c-gray-light">
                      In your niche of expertise, we send you topics and
                      questions that are trending on the web.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="feature feature--boxed-border">
                <div className="icon-block icon-block--style-1-v1">
                  <div className="block-icon">
                    <span className="icon-number">3</span>
                  </div>
                  <div className="block-content">
                    <h3 className="heading heading-6 strong-600">
                      You Send Back Bullet Points.
                    </h3>
                    <p className="mt-2 c-gray-light">
                      You send back bullet points answering each of our
                      questions, or hop on a call with us to answer the
                      questions.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="feature feature--boxed-border">
                <div className="icon-block icon-block--style-1-v1">
                  <div className="block-icon">
                    <span className="icon-number">4</span>
                  </div>
                  <div className="block-content">
                    <h3 className="heading heading-6 strong-600">
                      We LinkedIn-ify them and post.
                    </h3>
                    <p className="mt-2 c-gray-light">
                      We write your posts for you, based on the bullet points
                      you send back. After your review, we will post.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="feature feature--boxed-border">
                <div className="icon-block icon-block--style-1-v1">
                  <div className="block-icon">
                    <span className="icon-number">5</span>
                  </div>
                  <div className="block-content">
                    <h3 className="heading heading-6 strong-600">
                      We use our network of influencers to boost your reach.
                    </h3>
                    <p className="mt-2 c-gray-light">
                      We have a group of influencers that will comment on, and
                      like your posts to drive engagement to your post.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="feature feature--boxed-border">
                <div className="icon-block icon-block--style-1-v1">
                  <div className="block-icon">
                    <span className="icon-number">6</span>
                  </div>
                  <div className="block-content">
                    <h3 className="heading heading-6 strong-600">
                      Watch your influence skyrocket.
                    </h3>
                    <p className="mt-2 c-gray-light">
                      Over time, watch your network, connections, and followers
                      grow! Your leads will know about you before you reach out.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="slice-lg sct-color-1">
      <div className="container">
        <div className="section-title section-title--style-1 text-center">
          <h3 className="section-title-inner strong-500 text-capitalize">
            What Our Clients Say About Us
          </h3>
        </div>

        <span className="space-xs-xl" />

        <div className="row cols-xs-space cols-md-space cols-lg-space">
          <div className="col-lg-6">
            <div className="card card-blockquote z-depth-3-top">
              <div className="card-body">
                <div className="block-author">
                  <div className="author-image ">
                    <img src={john} />
                  </div>
                  <div className="author-info">
                    <span className="d-block heading-6 author-name strong-600 c-base-1">
                      John Frye
                    </span>
                    <span className="heading-xs author-desc">
                      Digital Marketing @ Bevy Labs
                    </span>
                  </div>
                </div>

                <p className="mt-4 line-height-1_8">
                  Jamocha gave me the framework that got my content from 100
                  views to 5k, 10k and 20k+ views on each post.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="card card-blockquote z-depth-3-top">
              <div className="card-body">
                <div className="block-author">
                  <div className="author-image ">
                    <img src={sierra} />
                  </div>
                  <div className="author-info">
                    <span className="d-block heading-6 author-name strong-600 c-base-1">
                      Sierra Clark
                    </span>
                    <span className="heading-xs author-desc">
                      Head of Digital @ Nodle.io
                    </span>
                  </div>
                </div>

                <p className="mt-4 line-height-1_8">
                  Jamocha Media is a game changer. Jamocha Media's social
                  influence in the LinkedIn space is the best we've seen, and
                  boosted our engagement by thousands of views. Jamocha Media is
                  a simple yet genius company. Would recommend to a friend.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="slice-lg sct-color-2 border-bottom">
      <div className="container text-center">
        <div className="row">
          <div className="col-md-12">
            <div className="section-title section-title--style-1 text-center mb-4">
              <h3 className="section-title-inner heading-2 text-normal">
                Pricing starts at $2000/mo.
              </h3>
              <span className="section-title-delimiter clearfix d-none" />
            </div>

            <span className="clearfix" />

            <div className="fluid-paragraph fluid-paragraph-sm text-center">
              <p className="text-lg line-height-1_8 c-gray-light">
                This includes LinkedIn Strategy and one post a week.
                <br />
                Join the likes of CEOs, venture capitalists, CNN regulars, and
                best selling authors.
              </p>

              <a
                href="https://jamocha.typeform.com/to/sK6FkT"
                target="_blank"
                className="btn btn-styled btn-base-1 btn-circle mt-4"
              >
                Reach Out Today!
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js